import { Link } from 'react-router-dom';

// Social handles — pulled from env vars so deploy can flip them on without
// a code change. If a var is empty, the corresponding icon is not rendered
// (better than a dead href="#" link). Set in Vercel → Project → Settings →
// Environment Variables.
const SOCIAL = {
  linkedin: import.meta.env.VITE_SOCIAL_LINKEDIN || '',
  twitter:  import.meta.env.VITE_SOCIAL_TWITTER  || '',
  facebook: import.meta.env.VITE_SOCIAL_FACEBOOK || '',
};

export function WebsiteFooter() {
  return (
    <footer className="bg-[#1E293B] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="h-8 w-8 bg-[#6366F1] rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">B</span>
              </div>
              <span className="text-xl font-bold">BrixLead</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              AI-powered CRM that captures, assigns, nurtures, and converts leads automatically.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-slate-300 mb-4">Product</h4>
            <ul className="space-y-2.5">
              <li><Link to="/features" className="text-sm text-slate-400 hover:text-white transition-colors">Features</Link></li>
              <li><Link to="/pricing" className="text-sm text-slate-400 hover:text-white transition-colors">Pricing</Link></li>
              <li><Link to="/docs/api" className="text-sm text-slate-400 hover:text-white transition-colors">API Docs</Link></li>
              <li><Link to="/register" className="text-sm text-slate-400 hover:text-white transition-colors">Get Started</Link></li>
              <li><Link to="/login" className="text-sm text-slate-400 hover:text-white transition-colors">Login</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-slate-300 mb-4">Resources</h4>
            <ul className="space-y-2.5">
              <li><Link to="/help" className="text-sm text-slate-400 hover:text-white transition-colors">Help Center</Link></li>
              <li><Link to="/contact" className="text-sm text-slate-400 hover:text-white transition-colors">Contact Sales</Link></li>
              <li><Link to="/about" className="text-sm text-slate-400 hover:text-white transition-colors">About Us</Link></li>
              <li>
                <a
                  href={import.meta.env.VITE_STATUS_URL || 'https://stats.uptimerobot.com/brixlead'}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-slate-400 hover:text-white transition-colors inline-flex items-center gap-1.5"
                >
                  <span className="h-2 w-2 rounded-full bg-emerald-400 animate-pulse" />
                  System Status
                </a>
              </li>
            </ul>
          </div>

          {/* Legal + contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-slate-300 mb-4">Legal</h4>
            <ul className="space-y-2.5">
              <li><Link to="/privacy" className="text-sm text-slate-400 hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-sm text-slate-400 hover:text-white transition-colors">Terms of Service</Link></li>
              <li><a href="mailto:support@brixlead.com" className="text-sm text-slate-400 hover:text-white transition-colors">support@brixlead.com</a></li>
            </ul>
            {(SOCIAL.linkedin || SOCIAL.twitter || SOCIAL.facebook) && (
              <div className="flex gap-3 mt-4">
                {SOCIAL.linkedin && (
                  <a href={SOCIAL.linkedin} target="_blank" rel="noopener noreferrer"
                    className="h-9 w-9 rounded-full bg-slate-700 hover:bg-[#6366F1] flex items-center justify-center transition-colors text-xs font-bold">
                    in
                  </a>
                )}
                {SOCIAL.twitter && (
                  <a href={SOCIAL.twitter} target="_blank" rel="noopener noreferrer"
                    className="h-9 w-9 rounded-full bg-slate-700 hover:bg-[#6366F1] flex items-center justify-center transition-colors text-xs font-bold">
                    X
                  </a>
                )}
                {SOCIAL.facebook && (
                  <a href={SOCIAL.facebook} target="_blank" rel="noopener noreferrer"
                    className="h-9 w-9 rounded-full bg-slate-700 hover:bg-[#6366F1] flex items-center justify-center transition-colors text-xs font-bold">
                    fb
                  </a>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="border-t border-slate-700 mt-12 pt-8 text-center">
          <p className="text-sm text-slate-500">&copy; {new Date().getFullYear()} BrixLead. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
